import { Component, OnInit } from '@angular/core';
import { ApplicationConfigurationDto } from '../../admin/admin-general/dto/application-configuration.dto';
import { AdminService } from '../../shared/services/admin.service';
import { TitleService } from '../../shared/services/title.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public loading: boolean = false;
  public hasLoginFailed: number = 0;
  public maintenanceMode: boolean = false;

  constructor(
    private readonly titleService: TitleService,
    private readonly authService: AuthService,
    private readonly adminService: AdminService,
  ) {}

  public async ngOnInit(): Promise<void> {
    const applicationConfiguration: ApplicationConfigurationDto = await this.adminService.getApplicationConfiguration();
    this.maintenanceMode = applicationConfiguration?.maintenance ?? false;
    this.titleService.setTitle('Connexion');
  }

  public resetLoginFailed(): void {
    this.hasLoginFailed = 0;
  }

  public async sngLogin(): Promise<void> {
    this.resetLoginFailed();
    await this.authService.sngSignIn();
  }

  public pcLogin() {
    this.resetLoginFailed();
    this.authService.pcSignIn();
  }
}
